import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'
import {ModalProgramDescSimplificadaComponent} from '../modal-program-desc-simplificada/modal-program-desc-simplificada.component'

@Component({
  selector: 'dmmp-search-programs-desc-simplificada',
  templateUrl: './search-programs-desc-simplificada.component.html'
})
export class SearchProgramsDescSimplificadaComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() filterPrograms
  @Input() categories = []
  @Input() textNoFound = 'No se encontraron resultados'
  @Input() textAll = 'Todos'
  @Output() categoryOut = new EventEmitter()
  @Output() categoriesOut = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  status = true
  notEmptyPost = true
  statusInit = 8
  searchModel

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
  }

  click(category) {
    this.categoryOut.emit(category)
  }

  sendData(data, identifier) {
    this.status = false
    const modalRef = this.modalService.open(ModalProgramDescSimplificadaComponent, {size: 'lg'})
    modalRef.componentInstance.data = data
    modalRef.componentInstance.identifier = identifier
    modalRef.componentInstance.categoriesOut.subscribe(($e) => {
      this.categoriesOut.emit($e)
    })
    modalRef.componentInstance.anchorCustom.subscribe(($e) => {
      this.anchorCustom.emit($e)
    })
  }

  onScroll() {
    if (this.notEmptyPost) {
      this.statusInit += 8
    }
  }
}
